// extracted by mini-css-extract-plugin
export var container = "verticalTextLiftList-module--container--2RU8W";
export var verticalLift = "verticalTextLiftList-module--verticalLift--nQx1D";